__turbopack_context__.v({
  "badgeContainer": "wU2kQq_badgeContainer",
  "buttonGroup": "wU2kQq_buttonGroup",
  "carouselImage": "wU2kQq_carouselImage",
  "carouselImagePrivateOffice": "wU2kQq_carouselImagePrivateOffice",
  "carouselImageRestricted": "wU2kQq_carouselImageRestricted",
  "container": "wU2kQq_container",
  "copy": "wU2kQq_copy",
  "floorplanButton": "wU2kQq_floorplanButton",
  "heroImageRoot": "wU2kQq_heroImageRoot",
  "image": "wU2kQq_image",
  "imageGalleryButton": "wU2kQq_imageGalleryButton",
  "imageGalleryRow": "wU2kQq_imageGalleryRow",
  "imageWrapper": "wU2kQq_imageWrapper",
  "imageWrapperBig0": "wU2kQq_imageWrapperBig0",
  "imageWrapperBig1": "wU2kQq_imageWrapperBig1",
  "imageWrapperSmall0": "wU2kQq_imageWrapperSmall0",
  "imageWrapperSmall1": "wU2kQq_imageWrapperSmall1",
  "noImagesContainer": "wU2kQq_noImagesContainer",
  "privateOfficeCarouselWrapper": "wU2kQq_privateOfficeCarouselWrapper",
  "propertyImageSlider": "wU2kQq_propertyImageSlider",
  "restrictedOverlayImage": "wU2kQq_restrictedOverlayImage",
  "vtourButton": "wU2kQq_vtourButton",
  "wrapper": "wU2kQq_wrapper",
});
